import React from "react";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

interface ConfirmDeactivateContentProps {
  onConfirm: () => void;
  onCancel: () => void;
  regionalName: string;
  isLoading?: boolean;
}

export function ConfirmDeactivateContent({
  onConfirm,
  onCancel,
  regionalName,
  isLoading = false,
}: ConfirmDeactivateContentProps) {
  const handleConfirm = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onConfirm();
  };

  return (
    <div className="space-y-4">
      <div className="space-y-4 pt-2">
        <p className="text-gray-700 text-lg">
          Você está prestes a desativar o regional{" "}
          <span className="font-extrabold text-red-600">"{regionalName}"</span>.
        </p>

        <div className="rounded-lg border-2 border-yellow-600 bg-yellow-50 p-4 flex items-start space-x-3 shadow-md">
          <AlertCircle className="h-6 w-6 text-yellow-700 mt-0.5 flex-shrink-0" />
          <div>
            <strong className="text-yellow-900 text-base block mb-1">
              Impacto Imediato:
            </strong>
            <p className="text-sm text-yellow-800">
              Todas as <strong>lojas vinculadas</strong> serão automaticamente{" "}
              <strong>desvinculadas</strong> (removidas do regional).
            </p>
          </div>
        </div>

        <p className="text-gray-900 font-bold pt-4 text-base">
          Tem certeza absoluta que deseja prosseguir com a desativação?
        </p>
      </div>

      {/* Footer com botões */}
      <div className="flex justify-end gap-3 pt-6 border-t">
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          disabled={isLoading}
          className="text-gray-600 border-gray-300 hover:bg-gray-50"
        >
          Cancelar
        </Button>

        <Button
          type="button"
          onClick={handleConfirm}
          disabled={isLoading}
          className="bg-red-600 hover:bg-red-700 focus:ring-red-500 text-white transition-colors px-6"
        >
          {isLoading ? "Desativando..." : "Sim, Desativar"}
        </Button>
      </div>
    </div>
  );
}